import {
  useApolloClient,
  gql,
  MutationHookOptions,
  TypedDocumentNode,
} from '@apollo/client'
import { useSetCartId } from '@emico-hooks/cart-id'
import { useAuthorizationContext } from '@emico-hooks/login-token'
import { useCallback } from 'react'

import {
  CreateCartMutation,
  CreateCartMutationVariables,
} from './useCreateCart.generated'

const mutation = gql`
  mutation CreateCart {
    createEmptyCart
  }
` as TypedDocumentNode<CreateCartMutation, CreateCartMutationVariables>

export function useCreateCart() {
  const authorizationContext = useAuthorizationContext()
  const setCartId = useSetCartId()

  const client = useApolloClient()

  return useCallback(
    async (
      updateCartIdVar: boolean = true,
      options?: Omit<
        MutationHookOptions<CreateCartMutation, CreateCartMutationVariables>,
        'mutation'
      >,
    ) => {
      const { data, errors } = await client.mutate({
        mutation,
        update: updateCartIdVar
          ? (_, { data }) => {
              setCartId(data?.createEmptyCart ?? undefined)
            }
          : undefined,
        context: authorizationContext,
        ...options,
      })

      if (errors && errors[0]) {
        throw errors[0]
      }

      if (!data || !data.createEmptyCart) {
        throw new Error('Received an empty response while creating a new cart')
      }

      return data.createEmptyCart
    },
    [authorizationContext, client, setCartId],
  )
}
